import { Dispatch } from "react"
import { GETAPI, POSTAPI } from "../../api/Api"
import {    USER_LOGIN_RESET , USER_LOGIN_REQUEST , USER_LOGIN_SUCCESS , USER_LOGIN_FAIL , 
            USER_REGISTRATION_RESET , USER_REGISTRATION_REQUEST , USER_REGISTRATION_SUCCESS , USER_REGISTRATION_FAIL , 
            USER_FORGOT_PASSWORD_RESET , USER_FORGOT_PASSWORD_REQUEST , USER_FORGOT_PASSWORD_SUCCESS , USER_FORGOT_PASSWORD_FAIL  ,
            USER_RESET_PASSWORD_RESET , USER_RESET_PASSWORD_REQUEST ,USER_RESET_PASSWORD_SUCCESS , USER_RESET_PASSWORD_FAIL , 
            UPDATE_PROFILE_RESET , UPDATE_PROFILE_REQUEST , UPDATE_PROFILE_SUCCESS ,UPDATE_PROFILE_FAIL ,
            CHANGE_PASSWORD_RESET , CHANGE_PASSWORD_REQUEST ,CHANGE_PASSWORD_SUCCESS ,CHANGE_PASSWORD_FAIL ,
            USER_SETTING_RESET , USER_SETTING_REQUEST , USER_SETTING_SUCCESS ,USER_SETTING_FAIL,
            USER_GET_PROFILE_RESET , USER_GET_PROFILE_REQUEST , USER_GET_PROFILE_SUCCESS , USER_GET_PROFILE_FAIL,
            GET_ORDERS_RESET ,GET_ORDERS_REQUEST ,GET_ORDERS_SUCCESS,GET_ORDERS_FAIL, 
            GET_ITEMS_RESET , GET_ITEMS_REQUEST , GET_ITEMS_SUCCESS , GET_ITEMS_FAIL,
            ORDER_DETAIL_RESET , ORDER_DETAIL_REQUEST , ORDER_DETAIL_SUCCESS , ORDER_DETAIL_FAIL } from "../../constants/UserConstants";
import { renderFormData } from "../../utils/Helper";


export const LoginAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: USER_LOGIN_RESET });
    }
    else {
        try {
            dispatch({
                type: USER_LOGIN_FAIL
            });
            let data = await POSTAPI('login', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: USER_LOGIN_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: USER_LOGIN_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: USER_LOGIN_FAIL,
                payload: error.message
            });
        }
    }
};

export const RegistrationAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: USER_REGISTRATION_RESET });
    }
    else {
        try {
            dispatch({
                type: USER_REGISTRATION_FAIL
            });
            let data = await POSTAPI('registration', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: USER_REGISTRATION_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: USER_REGISTRATION_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: USER_REGISTRATION_FAIL,
                payload: error.message
            });
        }
    }
};


export const ForgotPasswordAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: USER_FORGOT_PASSWORD_RESET });
    }
    else {
        try {
            dispatch({
                type: USER_FORGOT_PASSWORD_FAIL
            });
            let data = await POSTAPI('forgot-password', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: USER_FORGOT_PASSWORD_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: USER_FORGOT_PASSWORD_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: USER_FORGOT_PASSWORD_FAIL,
                payload: error.message
            });
        }
    }
};


export const ResetPasswordAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: USER_RESET_PASSWORD_RESET });
    }
    else {
        try {
            dispatch({
                type: USER_RESET_PASSWORD_FAIL
            });
            let data = await POSTAPI('reset-password', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: USER_RESET_PASSWORD_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: USER_RESET_PASSWORD_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: USER_RESET_PASSWORD_FAIL,
                payload: error.message
            });
        }
    }
};


export const UpdateProfileAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: UPDATE_PROFILE_RESET });
    }
    else {
        try {
            dispatch({
                type: UPDATE_PROFILE_FAIL
            });
            let data = await POSTAPI('update-profile', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: UPDATE_PROFILE_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: UPDATE_PROFILE_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: UPDATE_PROFILE_FAIL,
                payload: error.message
            });
        }
    }
};

export const ChangePasswordAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: CHANGE_PASSWORD_RESET });
    }
    else {
        try {
            dispatch({
                type: CHANGE_PASSWORD_FAIL
            });
            let data = await POSTAPI('change-password', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: CHANGE_PASSWORD_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: CHANGE_PASSWORD_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: CHANGE_PASSWORD_FAIL,
                payload: error.message
            });
        }
    }
};

export const SettingAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: USER_SETTING_RESET });
    }
    else {
        try {
            dispatch({
                type: USER_SETTING_FAIL
            });
            let data = await POSTAPI('setting', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: USER_SETTING_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: USER_SETTING_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: USER_SETTING_FAIL,
                payload: error.message
            });
        }
    }
};

export const GetProfileAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: USER_GET_PROFILE_RESET });
    }
    else {
        try {
            dispatch({
                type: USER_GET_PROFILE_FAIL
            });
            let data = await POSTAPI('get-profile', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: USER_GET_PROFILE_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: USER_GET_PROFILE_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: USER_GET_PROFILE_FAIL,
                payload: error.message
            });
        }
    }
};

export const GetOrdersAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: GET_ORDERS_RESET });
    }
    else {
        try {
            dispatch({
                type: GET_ORDERS_FAIL
            });
            let data = await POSTAPI('get-orders', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: GET_ORDERS_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: GET_ORDERS_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: GET_ORDERS_FAIL,
                payload: error.message
            });
        }
    }
};

export const OrderDetailAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: ORDER_DETAIL_RESET });
    } else {
        try {
            dispatch({
                type: ORDER_DETAIL_FAIL
            });
            let data = await POSTAPI('order-details', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: ORDER_DETAIL_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: ORDER_DETAIL_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: ORDER_DETAIL_FAIL,
                payload: error.message
            });
        }
    }
};

export const GetItemsAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: GET_ITEMS_RESET });
    }
    else {
        try {
            dispatch({
                type: GET_ITEMS_FAIL
            });
            let data = await POSTAPI('get-items', payload, false);
            if (data && data?.status === true) {
                dispatch({
                    type: GET_ITEMS_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: GET_ITEMS_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: GET_ITEMS_FAIL,
                payload: error.message
            });
        }
    }
};